import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const AuthContext = createContext(null);

// Token expira en 12 horas
const TOKEN_EXPIRATION_MS = 12 * 60 * 60 * 1000;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Cargar estado inicial desde sessionStorage
  useEffect(() => {
    const storedUser = sessionStorage.getItem("usuario");
    const storedToken = sessionStorage.getItem("x-access-token");
    const expiration = sessionStorage.getItem("x-access-token-expiration");

    if (storedUser && storedToken && expiration) {
      if (Number(expiration) > Date.now()) {
        setUser(JSON.parse(storedUser));
        setToken(storedToken);
      } else {
        // Token expirado, limpiar
        sessionStorage.removeItem("usuario");
        sessionStorage.removeItem("x-access-token");
        sessionStorage.removeItem("x-access-token-expiration");
      }
    }
    setIsLoading(false);
  }, []);

  const login = useCallback((userData, authToken) => {
    setUser(userData);
    setToken(authToken);

    sessionStorage.setItem("usuario", JSON.stringify(userData));
    sessionStorage.setItem("x-access-token", authToken);
    sessionStorage.setItem(
      "x-access-token-expiration",
      String(Date.now() + TOKEN_EXPIRATION_MS)
    );
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    setToken(null);

    sessionStorage.removeItem("usuario");
    sessionStorage.removeItem("x-access-token");
    sessionStorage.removeItem("x-access-token-expiration");
  }, []);

  const isAuthenticated = useCallback(() => {
    const expiration = sessionStorage.getItem("x-access-token-expiration");
    return token && expiration && Number(expiration) > Date.now();
  }, [token]);

  const value = {
    user,
    token,
    isLoading,
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth debe usarse dentro de un AuthProvider");
  }
  return context;
}

export default AuthContext;
